import React, { use, useEffect, useState } from "react";
import Swal from "sweetalert2";
import DynamicForm from "../../../data/Axios/DynamicForm";
import {
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";

import {
  AccountsandFinanceurl,
  companyManagementUrl,
  salesManagement,
  setupManagementUrl,
} from "../../../config";

import { paymentVoucherFields } from "../../../data/DynamicTable/CompanyManagementForms";
import {
  allAccountSubCategories,
  allBanks,
  allRegions,
  PaymentMethodQuery,
} from "../../../data/Axios/queries";
import { grid } from "@mui/system";

const base_url = companyManagementUrl.uri;

const PaymentVoucherForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);
  const purchases = JSON.parse(localStorage.getItem("purchaseorderid"));
  const [isEditing, setIsEditing] = useState(props.isEditing || false);
  const [outstandingBalance, setOutstandingBalance] = useState(0);

  const getTodayLocalDate = () => {
    const now = new Date();
    const pad = (n) => String(n).padStart(2, "0");
    return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
  };

  const toDateInputValue = (value) => {
    if (!value) return "";
    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";

    const pad = (n) => String(n).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  };

  useEffect(() => {
    if (purchases) {
      if (!props.isEditing) {
        setIsEditing(false);
      }
      setOutstandingBalance(purchases.outstandingBalance);
    } else {
      const fetchOutstandingBalance = async () => {
        try {
          const storedpurchase = localStorage.getItem("purchaseorderid");
          const purchases = storedpurchase ? JSON.parse(storedpurchase) : null;

          if (
            purchases &&
            outstandingBalance !== undefined &&
            outstandingBalance !== null
          ) {
            setOutstandingBalance(purchases.outstandingBalance);
          } else {
            const query = `
          query PurchaseOrderById {
            purchaseOrderById(purchaseOrder: { id: ${props.data.purchaseOrderId} }) {
              outstandingBalance
            }
          }
        `;

            const response = await graphqlQuery(query, salesManagement.uri);

            // ✅ Access the actual balance value from the returned object
            const balance = response?.outstandingBalance ?? 0;
            setOutstandingBalance(balance);
          }
        } catch (error) {
          console.error("Error fetching OutstandingBalance:", error);
          setOutstandingBalance(0);
        }
      };

      fetchOutstandingBalance();
    }
  }, [purchases, salesManagement.uri]);

  useEffect(() => {
    const fetchPaymentAccounts = async () => {
      if (props.isEditing === true) {
        const accountQuery = `
          {
            accountsBySubCategoryId(functionparams: { accountSubcategoryId: ${props.data.paymentMethod} }) {
              id
              accountName
            }
          }`;
        const accountSubcategory = await graphqlQuery(
          accountQuery,
          AccountsandFinanceurl.uri,
        );

        if (accountSubcategory) {
          const accountsOptions = accountSubcategory.map((account) => ({
            value: account.id,
            label: account.accountName,
          }));
          setAccountData(accountsOptions);
        } else {
          setAccountData([]);
        }
      }
    };

    fetchPaymentAccounts();
  }, [props?.data?.paymentMethod]);

  const initialValues = {
    paymentMethod: props.data ? props.data.paymentMethod : "",
    paymentAccountId: props.data ? props.data.paymentAccountId : "",
    amountPaid: props.data
      ? props.data.paidAmount
        ? props.data.paidAmount
        : props.data.outstandingBalance
      : outstandingBalance
        ? outstandingBalance
        : 0.0,
    paymentDate: props.isEditing
      ? toDateInputValue(props.data?.paymentDate)
      : getTodayLocalDate(),
    reference: props.data ? props.data.reference : "",
    remarks: props.data ? props.data.remarks : "",
    OutstandingBalance: outstandingBalance
      ? outstandingBalance
      : props.data
        ? props.data.outstandingBalance
        : 0.0,
  };

  const [paymentData, setPaymentData] = useState([]);
  const [accountData, setAccountData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    async function fetchAllData() {
      try {
        const paymentMethod = await graphqlQuery(
          PaymentMethodQuery,
          AccountsandFinanceurl.uri,
        );
        if (paymentMethod) {
          setPaymentData(paymentMethod);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchAllData();
  }, []);
  const paymentOptions = paymentData.map((paymentData) => ({
    value: paymentData.id,
    label: paymentData.accountName,
  }));

  const fields = [
    {
      name: "paymentMethod",
      label: "Payment Method",
      type: "select", // e.g., Cash, Bank Transfer, Cheque
      options: paymentData.length > 0 ? paymentOptions : [],
      gridColumn: "span 2",
      required: true,
      parent: "main",
    },
    ...paymentVoucherFields,
    {
      name: "paymentAccountId",
      label: "Payment Account",
      type: "select", // dropdown for accounts
      options: accountData,
      gridColumn: "span 2",
      required: true,
      ...(props.isEditing
        ? {}
        : { parent: "dependent", dependentOn: "paymentMethod" }),
    },
    {
      name: "OutstandingBalance",
      label: "Outstanding Balance",
      type: "disabled",
      gridColumn: "span 4",
      hidden: true,
      disabled: true,
      initialValue: props.data ? props.data.outstandingBalance : "",
    },
  ];
  const handleFieldChange = async (field, value) => {
    if (field.name === "paymentMethod") {
      const accountQuery = `{
      accountsBySubCategoryId(functionparams: { accountSubcategoryId: ${value} }) {
        id
        accountName
      }
    }`;
      const accountSubcategory = await graphqlQuery(
        accountQuery,
        AccountsandFinanceurl.uri,
      );

      if (accountSubcategory) {
        const accountsOptions = accountSubcategory.map((account) => ({
          value: account.id,
          label: account.accountName,
        }));
        setAccountData(accountsOptions);
        return accountsOptions;
      } else {
        return [];
      }
    }
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const {
        paymentMethod,
        remarks,
        reference,
        amountPaid,
        paymentDate,
        paymentAccountId,
      } = values;

      if (parseFloat(amountPaid) > parseFloat(outstandingBalance)) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Amount paid cannot exceed outstanding balance.",
        });
        setSubmitting(false);
        return;
      }
      const now = new Date();
      const pad = (n) => String(n).padStart(2, "0");
      const currentTime = `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
      const todayDate = getTodayLocalDate();

      const safeCreatedDate =
        paymentDate && paymentDate.trim() !== ""
          ? paymentDate
          : todayDate;

      const combinedDateTime = `${safeCreatedDate}T${currentTime}`;

      const mutationData = isEditing
        ? {
            id: props.data.paymentVoucherId,
            purchaseOrderId: props.data.purchaseOrderId,
            vendorId: props.data.vendorId,
            paymentMethod,
            amountPaid: parseFloat(amountPaid),
            paymentAccountId,
            paymentDate: combinedDateTime,
            reference: reference ? reference : props.data.reference,
            remarks: remarks ? remarks : props.data.remarks,
          }
        : {
            purchaseOrderId: parseInt(purchases.id),
            vendorId: parseInt(purchases.vendorid),
            paymentMethod,
            amountPaid: parseFloat(amountPaid),
            paymentAccountId,
            paymentDate: combinedDateTime,
            reference: reference ? reference : "",
            remarks,
            //pushingmain
          };

      const response = await generateAndExecuteMutation(
        isEditing ? "updatePaymentVoucher" : "createPaymentVoucher",
        mutationData,
        isEditing ? "updatePaymentVoucher" : "newPaymentVoucher",
        salesManagement.uri,
      );

      if (Object.values(response)[0] != null) {
        if (!isEditing) {
          props.onClose();
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: "Payment Voucher created successfully.",
            showCancelButton: true,
            confirmButtonText: "Proceed to Payment Voucher",
            cancelButtonText: "Remain",
          }).then((result) => {
            if (result.isConfirmed) {
              // Redirect to /paymentVoucher
              window.location.href = "/payment-voucher";
            } else {
              // Close modal and refresh or trigger action
              props.onClose();
              props.onAction?.();
              props.onServerAction?.();
            }
          });
        } else {
          props.onClose();
          props.onAction?.(); // setRefreshTable(true) — keeps non-server callers happy
          props.onServerAction?.(); // FIX 1: triggers fetchVouchers() in server-mode PV page
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: "Payment Voucher updated successfully.",
          });
        }
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };
  if (loading) {
    return <div className="justify-content-center">Loading...</div>;
  }
  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onSubmit={handleSubmit}
      title={
        isEditing ? "Edit Sales Payment Voucher" : "Create Payment Voucher"
      }
      onFieldChange={handleFieldChange}
      subtitle={
        isEditing
          ? "Edit an Existing Payment Voucher"
          : "Create a New Payment Voucher"
      }
    />
  );
};

export default PaymentVoucherForm;
